function Card({ title, text, image, alt }) {
    return (
        <div className="card">
            <div className="card-img">
                <img src={image} alt={alt} />
            </div>

            <div>
                <p className="card-title">{title}</p>
                <p className="card-text">{text}</p>
            </div>
        </div>
    )
}

export default Card;